// extracted by mini-css-extract-plugin
module.exports = {"container":"_1J_IGkYkgj15HEnVY1T9iO","infoIcon":"_3pY1BEOXfdWNUCiDkTxwcA"};